module.exports = __webpack_public_path__ + "static/media/joker.1a3efb7e.png";